import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';

// Espelha o breakpoint de .aside-competences (styles.module.scss): a partir de
// 1280px a avaliação de competências já aparece inline como coluna, então a
// tab correspondente deixa de fazer sentido e a barra nem deve renderizar.
const COMPETENCES_TAB_QUERY = '(max-width: 1279px)';
const supported = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

function useShowCompetencesTab() {
  const [show, setShow] = useState(() => (supported() ? window.matchMedia(COMPETENCES_TAB_QUERY).matches : false));

  useEffect(() => {
    if (!supported()) return undefined;
    const mq = window.matchMedia(COMPETENCES_TAB_QUERY);
    const handler = event => setShow(event.matches);
    setShow(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return show;
}

const TABS = [
  { value: 'redacao', label: 'Redação' },
  { value: 'competencias', label: 'Competências' }
];

function TabNavBar({ selectedTab, setSelectedTab }) {
  const showCompetencesTab = useShowCompetencesTab();
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  if (!showCompetencesTab) return null;

  if (isPlayfulTeacherTheme) {
    return (
      <div className="mb-6 inline-flex items-center gap-1 rounded-full border border-neutral-lighter bg-white p-1">
        {TABS.map(tab => {
          const isActive = selectedTab === tab.value;
          return (
            <button
              key={tab.value}
              type="button"
              onClick={() => setSelectedTab(tab.value)}
              className={cn('rounded-full px-4 py-1.5 text-sm font-semibold text-neutral-dark', isActive && '-translate-y-px font-extrabold text-white shadow-[0_3px_0_var(--color-mission-dark)]')}
              style={isActive ? { background: 'var(--color-mission)' } : undefined}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="tab mb-6">
      {TABS.map(tab => (
        <button
          key={tab.value}
          className={selectedTab === tab.value ? 'tab__link active' : 'tab__link'}
          onClick={() => setSelectedTab(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default TabNavBar;
